var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.643 8.48198C15.7386 4.47015 12.8598 2.45117 9.0006 2.45117C5.13944 2.45117 2.26266 4.47014 0.358194 8.48398C0.281805 8.64574 0.242188 8.8224 0.242188 9.00128C0.242188 9.18017 0.281805 9.35683 0.358194 9.51858C2.26266 13.5304 5.14145 15.5494 9.0006 15.5494C12.8618 15.5494 15.7386 13.5304 17.643 9.51657C17.7977 9.19113 17.7977 8.81345 17.643 8.48198ZM9.0006 14.103C5.7602 14.103 3.38766 12.4597 1.71422 9.00028C3.38766 5.5409 5.7602 3.8976 9.0006 3.8976C12.241 3.8976 14.6136 5.5409 16.287 9.00028C14.6156 12.4597 12.243 14.103 9.0006 14.103ZM8.92025 5.46457C6.96757 5.46457 5.38453 7.0476 5.38453 9.00028C5.38453 10.953 6.96757 12.536 8.92025 12.536C10.8729 12.536 12.456 10.953 12.456 9.00028C12.456 7.0476 10.8729 5.46457 8.92025 5.46457ZM8.92025 11.2503C7.67672 11.2503 6.67025 10.2438 6.67025 9.00028C6.67025 7.75675 7.67672 6.75028 8.92025 6.75028C10.1638 6.75028 11.1702 7.75675 11.1702 9.00028C11.1702 10.2438 10.1638 11.2503 8.92025 11.2503Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "97131/static/media/eye-icon.0f0df96ab253d2c5af9a304d0a6f9f32.svg";
export { ForwardRef as ReactComponent };